import { c as _c } from "react/compiler-runtime";
import { Accordion, Box, Button, Icon, Menu, Portal, Span } from "@chakra-ui/react";
import MobileCardHazard from "./mobile-card-hazard";
import { Hazards } from "../data/data";
import { Dispatch, SetStateAction } from "react";
import { LayerToggleObjProps } from "./address-mapper";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
type HazardData = {
  softStory?: any;
  tsunami?: any;
  liquefaction?: any;
};
const MobileReportHazards = t0 => {
  const $ = _c(21);
  const {
    showHazards,
    addressHazardData,
    isHazardDataLoading,
    toggledStates,
    setShowHazards,
    setToggledStates,
    setLayerToggleObj
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flip: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setShowHazards) {
    t2 = e => setShowHazards(e.open);
    $[1] = setShowHazards;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Span mr="2">Legend</Span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== showHazards) {
    t4 = <Menu.Trigger asChild={true}><Button textStyle="textMedium" layerStyle="mobileButton" fontWeight="bold" shadow="mobileButton">{t3}{!showHazards ? <Icon size="sm"><FaAngleDown /></Icon> : <Icon size="sm"><FaAngleUp /></Icon>}</Button></Menu.Trigger>;
    $[4] = showHazards;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [Hazards[0].name];
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== addressHazardData || $[8] !== isHazardDataLoading || $[9] !== setLayerToggleObj || $[10] !== setToggledStates || $[11] !== toggledStates) {
    t6 = Hazards.map(hazard => <MobileCardHazard key={hazard.id} hazard={hazard} hazardData={addressHazardData?.[hazard.name as keyof HazardData] ?? undefined} showData={hazard.name in addressHazardData ? true : false} isHazardDataLoading={isHazardDataLoading} toggledStates={toggledStates} setToggledStates={setToggledStates} setLayerToggleObj={setLayerToggleObj} />);
    $[7] = addressHazardData;
    $[8] = isHazardDataLoading;
    $[9] = setLayerToggleObj;
    $[10] = setToggledStates;
    $[11] = toggledStates;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <Portal><Menu.Positioner><Menu.Content p="0" borderRadius="2xl" py="3" w="full"><Accordion.Root collapsible={true} defaultValue={t5}>{t6}</Accordion.Root></Menu.Content></Menu.Positioner></Portal>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <Box pt="8" px="8" zIndex="docked" position="relative">{t4}{t7}</Box>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t8) {
    t9 = <Menu.Root positioning={t1} onOpenChange={t2}>{t8}</Menu.Root>;
    $[18] = t2;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default MobileReportHazards;